// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Nav **/
.list-group {
  border-radius: 0 !important;
  box-shadow: none !important;
}

.label-spacing {
  padding-top: 55px;
}

.flex-container {
  display: flex;
  align-content: stretch;
  padding-top: 10px;
  margin-top: 1%;
  margin-bottom: 1%;
}

.flex-send-button {
  flex: 1 0 15%;
}

.flex-logo {
  flex: 1 0 5%;
  color: lightgray;
}

.flex-detail-header {
  flex: 1 0 95%;
  color: lightgray;
}

.flex-detail {
  flex: 1 0 95%;
}

.flex-child {
  flex: 1 0 33%;
}

.flex-child-long {
  flex-grow: 12;
}

agm-map {
  height: 300px;
}

.ft-500 {
  font-weight:500;
}

.custom-search-component {
  display: flex;
  flex-direction: column;
  margin-right: 20px;
}

.selected-btn {
  background: lightgray;
}

.accept-decline {
  display: flex;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 20px;
}

.accept-decline .invitation-accepted,
.accept-decline .invitation-pending,
.accept-decline .invitation-refused {
  font-style: italic;
}
.accept-decline div {
  white-space: nowrap;
  text-align: right;
  margin-left: 5px;
}

.accept-decline span {
  margin-left: 15px;
}

.color-red {
  color:#c0392b;
}

/** Table **/

.thead-blue {
  color: #1b6d85;
}

.customTable {
  overflow: auto;
  border: 1px solid lightgray;
  min-height:160px;
  max-height:160px;
  margin-bottom: 10px;
}

/** Time spans AM/PM/AW **/
.time-span {
  background: #0077B5;
  border-radius: 2px;
  color: #fff;
  font-size: 13px;
  top: 2px;
  padding: .6em 1em;
}

/** Selected button **/
::ng-deep .p-button {
  white-space: nowrap;
  font-size: 14px;
}

::ng-deep .p-component {
  background-color: #ffffff;
  color: #3498db;
  border-radius: 2px;
  padding: .3em 1em;
}

::ng-deep .p-component.p-highlight{
  background-color: #3498db;
  color: #ffffff !important;
  border-radius: 2px;
  padding: .3em 1em;
}

/** Buttons **/
.row > button.btn-raised {
  width: 98%;
  height: 50px;
}

.btn.btn-raised {
  background-color: #0077B5;
  color: #ffffff;
}

.btn.btn-raised:hover, .btn.btn-raised:focus {
	background-color: #3788d8;
  color: #ffffff;
}

.btn:not(.btn-raised),
.input-group-btn .btn:not(.btn-raised),
.btn:not(.btn-raised).btn-default,
.input-group-btn .btn:not(.btn-raised).btn-default{
  color: rgba(0,0,0, 0.87);
}

::ng-deep .btn:not(.btn-raised):not(.btn-link):hover.btn-danger {
	background-color: #b92c28;
	color: rgba(255,255,255,.7) !important;
}

::ng-deep .btn-danger {
  background-repeat: repeat-x;
  color: rgba(255,255,255,.8) !important;
  border-color: #b92c28;
}

::ng-deep .btn-danger, .btn-default, .btn-info, .btn-primary, .btn-success, .btn-warning, .btn-transparent {
	text-shadow: none;
	box-shadow: none;
	color: rgba(255,255,255,.8)
}

/** Datepicker **/
::ng-deep .custom-p-calendar-input {
  width: auto;
  border: 1px solid #ccc;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 10000 !important;
}

::ng-deep .p-datepicker {
  color: #333;
}

::ng-deep .p-datepicker-header {
  padding: 10px;
  color: #333;
}

::ng-deep.p-datepicker-title {
	margin: 6px 35px;
  display: flex;
  justify-content: space-between;
}

::ng-deep .p-datepicker-title .p-datepicker-year {
	margin-left: 6px;
}

::ng-deep .p-datepicker table th {
  background-color: #E0E0E0;
  padding: 5px;
}

::ng-deep .p-datepicker table td > span {
  background-color: #ffffff;
  padding: 10px;
}

::ng-deep .p-datepicker table td:hover > span {
  background-color: #E0E0E0;
  color: #ffffff;
  padding: 8px;
  border-radius: 50%;
  outline: 1px solid #E0E0E0;
}

::ng-deep .p-datepicker table td.p-datepicker-today > span {
  background-color: #0077B5;
  color: #ffffff;
  padding: 8px;
  border-radius: 50%;
  outline: 1px solid #0077B5;
}

::ng-deep .p-datepicker table td.p-datepicker-other-month > span {
  color: #E0E0E0;
}

::ng-deep .p-datepicker table td.p-datepicker-other-month:hover > span {
  background-color: #EEEEEE;
  color: #ffffff;
  padding: 8px;
  border-radius: 50%;
  outline: 1px solid #EEEEEE;
}

/* Search */
.ui-tabview.ui-tabview-top .form-group.search {
	margin-bottom: 24px;
}
.ui-tabview.ui-tabview-top .form-group .search-before {
	position: absolute;
	color: #9f9f9f;
	top: 7px;
	left: 10px;
}
.ui-tabview.ui-tabview-top .form-group input#search {
	background: #fff;
	border-radius: 2px;
	box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
	padding: 6px 40px 6px 45px;
	transition: box-shadow .2s ease-out;
}
.ui-tabview.ui-tabview-top .form-group input#search:hover,
.ui-tabview.ui-tabview-top .form-group input#search:focus {
	box-shadow: 0 7px 14px rgba(0,0,0,0.25), 0 5px 5px rgba(0,0,0,0.22);
}
.ui-tabview.ui-tabview-top .form-group input#search + button#resetSearch {
	position: absolute;
    top: 4px;
    right: 2px;
    margin: 0;
    font-size: 21px;
    padding: 0px;
	color: #9f9f9f;
}
.ui-tabview.ui-tabview-top .form-group input#search + button#resetSearch:hover {
	text-decoration: none;
}
.ui-tabview.ui-tabview-top .form-group input#search + button#resetSearch i {
	top: 0;
}

/* Small devices (tablets, 768px and up) */
@media (max-width: 768px) {
  /* Search */
  .ui-tabview.ui-tabview-top .form-group {
    margin-bottom: 0;
  }
  .ui-tabview.ui-tabview-top .form-group .search-before {
    top: 10px;
    left: 18px;
    color: rgba(255,255,255,.2);
  }
  .ui-tabview.ui-tabview-top .form-group input#search {
    margin: 3px 8px 6px;
    width: calc(100% - 16px); /* margin 8px right + left */
    background: rgba(255,255,255,.05);
    color: #fff;
    box-shadow: none;
    font-weight: 300;
    transition: background .2s ease-in;
  }
  .ui-tabview.ui-tabview-top .form-group input#search:hover,
  .ui-tabview.ui-tabview-top .form-group input#search:focus {
    box-shadow: none;
    background: rgba(255,255,255,.15);
  }
  .ui-tabview.ui-tabview-top .form-group input#search + button#resetSearch {
    top: 7px;
    right: 10px;
    color: #fff;
  }

  .custom-search-component {
    display: flex;
    flex-direction: column;
    margin-left: 80px;
  }

  ul.list-group {
    display: flex;
    justify-content: space-evenly;
    margin-bottom: 60px;
  }
}

.main-buttons {
  margin-bottom: 2%;

  button {
    margin-right: 1%;
  }
}

.text-danger {
  color: red;
}

.text-primary {
  color: blue;
}

.text-warning {
  color: orange;
}

.text-success {
  color: green;
}

.text-warning-restore {
  color: yellow;
}
`, "",{"version":3,"sources":["webpack://./src/app/Components/Planning/planning.component.css"],"names":[],"mappings":"AAAA,UAAU;AACV;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;EAGE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA,YAAY;;AAEZ;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,QAAQ;EACR,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;CACC,yBAAyB;EACxB,cAAc;AAChB;;AAEA;;;;EAIE,wBAAwB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,sCAAsC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB;AACD;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,sBAAsB;EACtB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;CACC,gBAAgB;EACf,aAAa;EACb,8BAA8B;AAChC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,WAAW;AACX;CACC,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,cAAc;CACd,QAAQ;CACR,UAAU;AACX;AACA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,kEAAkE;CAClE,0BAA0B;CAC1B,mCAAmC;AACpC;AACA;;CAEC,mEAAmE;AACpE;AACA;CACC,kBAAkB;IACf,QAAQ;IACR,UAAU;IACV,SAAS;IACT,eAAe;IACf,YAAY;CACf,cAAc;AACf;AACA;CACC,qBAAqB;AACtB;AACA;CACC,MAAM;AACP;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,mBAAmB;IACnB,wBAAwB,EAAE,4BAA4B;IACtD,iCAAiC;IACjC,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kCAAkC;EACpC;EACA;;IAEE,gBAAgB;IAChB,iCAAiC;EACnC;EACA;IACE,QAAQ;IACR,WAAW;IACX,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;EACrB;AACF;;AAEA;EACE,iBAAiB;;EAEjB;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf","sourcesContent":["/** Nav **/\n.list-group {\n  border-radius: 0 !important;\n  box-shadow: none !important;\n}\n\n.label-spacing {\n  padding-top: 55px;\n}\n\n.flex-container {\n  display: flex;\n  align-content: stretch;\n  padding-top: 10px;\n  margin-top: 1%;\n  margin-bottom: 1%;\n}\n\n.flex-send-button {\n  flex: 1 0 15%;\n}\n\n.flex-logo {\n  flex: 1 0 5%;\n  color: lightgray;\n}\n\n.flex-detail-header {\n  flex: 1 0 95%;\n  color: lightgray;\n}\n\n.flex-detail {\n  flex: 1 0 95%;\n}\n\n.flex-child {\n  flex: 1 0 33%;\n}\n\n.flex-child-long {\n  flex-grow: 12;\n}\n\nagm-map {\n  height: 300px;\n}\n\n.ft-500 {\n  font-weight:500;\n}\n\n.custom-search-component {\n  display: flex;\n  flex-direction: column;\n  margin-right: 20px;\n}\n\n.selected-btn {\n  background: lightgray;\n}\n\n.accept-decline {\n  display: flex;\n  align-items: center;\n  margin-top: 8px;\n  margin-bottom: 20px;\n}\n\n.accept-decline .invitation-accepted,\n.accept-decline .invitation-pending,\n.accept-decline .invitation-refused {\n  font-style: italic;\n}\n.accept-decline div {\n  white-space: nowrap;\n  text-align: right;\n  margin-left: 5px;\n}\n\n.accept-decline span {\n  margin-left: 15px;\n}\n\n.color-red {\n  color:#c0392b;\n}\n\n/** Table **/\n\n.thead-blue {\n  color: #1b6d85;\n}\n\n.customTable {\n  overflow: auto;\n  border: 1px solid lightgray;\n  min-height:160px;\n  max-height:160px;\n  margin-bottom: 10px;\n}\n\n/** Time spans AM/PM/AW **/\n.time-span {\n  background: #0077B5;\n  border-radius: 2px;\n  color: #fff;\n  font-size: 13px;\n  top: 2px;\n  padding: .6em 1em;\n}\n\n/** Selected button **/\n::ng-deep .p-button {\n  white-space: nowrap;\n  font-size: 14px;\n}\n\n::ng-deep .p-component {\n  background-color: #ffffff;\n  color: #3498db;\n  border-radius: 2px;\n  padding: .3em 1em;\n}\n\n::ng-deep .p-component.p-highlight{\n  background-color: #3498db;\n  color: #ffffff !important;\n  border-radius: 2px;\n  padding: .3em 1em;\n}\n\n/** Buttons **/\n.row > button.btn-raised {\n  width: 98%;\n  height: 50px;\n}\n\n.btn.btn-raised {\n  background-color: #0077B5;\n  color: #ffffff;\n}\n\n.btn.btn-raised:hover, .btn.btn-raised:focus {\n\tbackground-color: #3788d8;\n  color: #ffffff;\n}\n\n.btn:not(.btn-raised),\n.input-group-btn .btn:not(.btn-raised),\n.btn:not(.btn-raised).btn-default,\n.input-group-btn .btn:not(.btn-raised).btn-default{\n  color: rgba(0,0,0, 0.87);\n}\n\n::ng-deep .btn:not(.btn-raised):not(.btn-link):hover.btn-danger {\n\tbackground-color: #b92c28;\n\tcolor: rgba(255,255,255,.7) !important;\n}\n\n::ng-deep .btn-danger {\n  background-repeat: repeat-x;\n  color: rgba(255,255,255,.8) !important;\n  border-color: #b92c28;\n}\n\n::ng-deep .btn-danger, .btn-default, .btn-info, .btn-primary, .btn-success, .btn-warning, .btn-transparent {\n\ttext-shadow: none;\n\tbox-shadow: none;\n\tcolor: rgba(255,255,255,.8)\n}\n\n/** Datepicker **/\n::ng-deep .custom-p-calendar-input {\n  width: auto;\n  border: 1px solid #ccc;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  z-index: 10000 !important;\n}\n\n::ng-deep .p-datepicker {\n  color: #333;\n}\n\n::ng-deep .p-datepicker-header {\n  padding: 10px;\n  color: #333;\n}\n\n::ng-deep.p-datepicker-title {\n\tmargin: 6px 35px;\n  display: flex;\n  justify-content: space-between;\n}\n\n::ng-deep .p-datepicker-title .p-datepicker-year {\n\tmargin-left: 6px;\n}\n\n::ng-deep .p-datepicker table th {\n  background-color: #E0E0E0;\n  padding: 5px;\n}\n\n::ng-deep .p-datepicker table td > span {\n  background-color: #ffffff;\n  padding: 10px;\n}\n\n::ng-deep .p-datepicker table td:hover > span {\n  background-color: #E0E0E0;\n  color: #ffffff;\n  padding: 8px;\n  border-radius: 50%;\n  outline: 1px solid #E0E0E0;\n}\n\n::ng-deep .p-datepicker table td.p-datepicker-today > span {\n  background-color: #0077B5;\n  color: #ffffff;\n  padding: 8px;\n  border-radius: 50%;\n  outline: 1px solid #0077B5;\n}\n\n::ng-deep .p-datepicker table td.p-datepicker-other-month > span {\n  color: #E0E0E0;\n}\n\n::ng-deep .p-datepicker table td.p-datepicker-other-month:hover > span {\n  background-color: #EEEEEE;\n  color: #ffffff;\n  padding: 8px;\n  border-radius: 50%;\n  outline: 1px solid #EEEEEE;\n}\n\n/* Search */\n.ui-tabview.ui-tabview-top .form-group.search {\n\tmargin-bottom: 24px;\n}\n.ui-tabview.ui-tabview-top .form-group .search-before {\n\tposition: absolute;\n\tcolor: #9f9f9f;\n\ttop: 7px;\n\tleft: 10px;\n}\n.ui-tabview.ui-tabview-top .form-group input#search {\n\tbackground: #fff;\n\tborder-radius: 2px;\n\tbox-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);\n\tpadding: 6px 40px 6px 45px;\n\ttransition: box-shadow .2s ease-out;\n}\n.ui-tabview.ui-tabview-top .form-group input#search:hover,\n.ui-tabview.ui-tabview-top .form-group input#search:focus {\n\tbox-shadow: 0 7px 14px rgba(0,0,0,0.25), 0 5px 5px rgba(0,0,0,0.22);\n}\n.ui-tabview.ui-tabview-top .form-group input#search + button#resetSearch {\n\tposition: absolute;\n    top: 4px;\n    right: 2px;\n    margin: 0;\n    font-size: 21px;\n    padding: 0px;\n\tcolor: #9f9f9f;\n}\n.ui-tabview.ui-tabview-top .form-group input#search + button#resetSearch:hover {\n\ttext-decoration: none;\n}\n.ui-tabview.ui-tabview-top .form-group input#search + button#resetSearch i {\n\ttop: 0;\n}\n\n/* Small devices (tablets, 768px and up) */\n@media (max-width: 768px) {\n  /* Search */\n  .ui-tabview.ui-tabview-top .form-group {\n    margin-bottom: 0;\n  }\n  .ui-tabview.ui-tabview-top .form-group .search-before {\n    top: 10px;\n    left: 18px;\n    color: rgba(255,255,255,.2);\n  }\n  .ui-tabview.ui-tabview-top .form-group input#search {\n    margin: 3px 8px 6px;\n    width: calc(100% - 16px); /* margin 8px right + left */\n    background: rgba(255,255,255,.05);\n    color: #fff;\n    box-shadow: none;\n    font-weight: 300;\n    transition: background .2s ease-in;\n  }\n  .ui-tabview.ui-tabview-top .form-group input#search:hover,\n  .ui-tabview.ui-tabview-top .form-group input#search:focus {\n    box-shadow: none;\n    background: rgba(255,255,255,.15);\n  }\n  .ui-tabview.ui-tabview-top .form-group input#search + button#resetSearch {\n    top: 7px;\n    right: 10px;\n    color: #fff;\n  }\n\n  .custom-search-component {\n    display: flex;\n    flex-direction: column;\n    margin-left: 80px;\n  }\n\n  ul.list-group {\n    display: flex;\n    justify-content: space-evenly;\n    margin-bottom: 60px;\n  }\n}\n\n.main-buttons {\n  margin-bottom: 2%;\n\n  button {\n    margin-right: 1%;\n  }\n}\n\n.text-danger {\n  color: red;\n}\n\n.text-primary {\n  color: blue;\n}\n\n.text-warning {\n  color: orange;\n}\n\n.text-success {\n  color: green;\n}\n\n.text-warning-restore {\n  color: yellow;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
